import React from "react";
import useTeamprofileStore from "./store/TeamprofileStore";
import Highlightcard from "../Athleteprofile/cards/highlightcard";
import Postcard from "../Athleteprofile/cards/postcard";
import {
  useTeamHighlights,
  useTeamPosts,
} from "../../api/teamprofile/queryHooks";
import { useParams } from "react-router-dom";
import { decodeId } from "../../api/utils";

const Badges = () => {
  return (
    <div className="text-left text-[#666666] text-sm font-semibold px-5">
      No badges earned yet. Watch this space as this team’s journey unfolds with
      achievements.
    </div>
  );
};

const Awards = () => {
  return (
    <div className="text-left text-[#666666] text-sm font-semibold px-5">
      No awards displayed yet. This team’s trophy cabinet is waiting for its
      first addition!
    </div>
  );
};

const Games = () => {
  return (
    <div className="text-left text-[#666666] text-sm font-semibold px-5">
      No games logged yet. This team’s sporting adventures are yet to be
      unveiled—stay connected!
    </div>
  );
};

const Posts = () => {
  const id = decodeId(useParams()?.id);
  const { data, isLoading } = useTeamPosts(1, 24, 0, 0, id);

  return (
    <div className="grid grid-cols-3 md:grid-cols-6 gap-1 px-5">
      {isLoading ? (
        Array.from({ length: 24 }).map((item, index) => (
          <div
            key={index}
            className={`aspect-[3/4] bg-[#333333] rounded-lg skeleton`}
          ></div>
        ))
      ) : data?.data?.post?.length ? (
        data.data.post.map((post) => <Postcard key={post.id} data={post} />)
      ) : (
        <div className="text-left text-[#666666] text-sm font-semibold col-span-6">
          This team hasn’t posted yet. Keep following for updates—they might
          share something exciting soon!
        </div>
      )}
    </div>
  );
};

const Highlights = () => {
  const id = decodeId(useParams()?.id);

  const { data, isLoading } = useTeamHighlights(1, 24, 0, 0, id);

  return (
    <div className="grid grid-cols-3 md:grid-cols-6 gap-1 px-5">
      {isLoading ? (
        Array.from({ length: 24 }).map((item, index) => (
          <div
            key={index}
            className={`aspect-[3/4] bg-[#333333] rounded-lg skeleton`}
          ></div>
        ))
      ) : data?.data?.highlights?.length ? (
        data.data.highlights.map((highlight) => (
          <Highlightcard key={highlight.id} data={highlight} />
        ))
      ) : (
        <div className="text-left text-[#666666] text-sm font-semibold col-span-6">
          No highlights shared yet. This team’s top moments are still in the
          making—stay tuned!
        </div>
      )}
    </div>
  );
};

const ContentContainerTab = () => {
  const selectedOption = useTeamprofileStore(
    (state) => state.currentContentTab
  );

  if (selectedOption === null) return null;

  const Items = {
    1: Highlights,
    2: Posts,
    3: Games,
    4: Awards,
    5: Badges,
  };

  const Item = Items?.[selectedOption.id];
  if (Item) return <Item />;
};

export default ContentContainerTab;
